<template>
  <div class="battery-add">
    <div class="row">
      <div class="label">电池二维码</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="linkNumber"></el-input>
        <el-upload
          style="display: inline-block"
          action=""
          accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="uploadQrcode">
          <span class="text-btn ml10" style="color: #67aa42">上传二维码</span>
        </el-upload>
      </div>
    </div>
    <div class="row">
      <div class="label">壳体编号</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="shellNo"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">通讯板编号</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="communicationBoardNo"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">可换电池规格</div>
      <div class="row-right">
        <el-radio-group v-model="ratedVoltageStandard">
          <el-radio :label="48">48V</el-radio>
          <el-radio :label="60">60V/72V</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <div class="label">版本</div>
      <div class="row-right">
        <el-select v-model="version">
          <el-option
            v-for="item in versionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'batteryMgmtAddView',
  data() {
    return {
      linkNumber: '',
      shellNo: '',
      communicationBoardNo: '',
      ratedVoltageStandard: '',
      version: '',
      versionList: [
        {
          id: "1",
          name: "v1.0"
        },
        {
          id: "2",
          name: "v2.0"
        },
        {
          id: "3",
          name: "v3.0"
        },
        {
          id: "4",
          name: "v3.1"
        },
        {
          id: "5",
          name: "v4.0"
        }
      ]
    };
  },
  mounted() {

  },
  methods: {
    uploadQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        let linkNo = res.data;
        this.linkNumber = Utils.getQueryParam(linkNo, 'qrcode');
      });
    },
    confirm() {
      this.addOrEditDevice();
    },
    cancel() {
      this.$emit('cancel');
    },
    addOrEditDevice() {
      let self = this;
      let params = {
        linkNumber: this.linkNumber,
        shellNo: this.shellNo,
        communicationBoardNo: this.communicationBoardNo,
        ratedVoltageStandard: this.ratedVoltageStandard,
        version: this.version,
      };
      this.$http.post('/managementPlatform/electricity/batteryInStock', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "添加成功!",
          center: true
        });
        self.$emit('addSuccess');
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryMgmtAddView.vue